import React from "react"
// import Container from "./Container"
import Video from "./Video"
import NavButton from "./NavButton"
import useConfig from "./useConfig"
import usePairedSegments from "./usePairedSegments"
import "./Orbits.css"

// const role = process.env.REACT_APP_ROLE

const Orbits = ({ segments }) => {
  const { videos, current, left, right, playing, onPlay, onEnd } = usePairedSegments(segments)

  return (
    <div style={{ background: "red", overflow: "hidden" }} className="orbits">
      <div style={{ overflow: "hidden" }} z={5}>
        {videos.map(url => (
          <Video
            isVisible={url === current}
            className={`orbit-vid`}
            key={url}
            url={url}
            playing={playing === url}
            onEnd={onEnd}
          />
        ))}
      </div>
      <div z={10}>
        <NavButton
          className="left"
          onClick={() => {
            onPlay(left)
          }}
        >
          <img
            style={{ height: "50px", width: "50px" }}
            src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/close-icon-left.svg`}
            alt="left"
          />
        </NavButton>
        {/* )} */}
        <NavButton
          className="right"
          onClick={() => {
            onPlay(right)
          }}
        >
          <img
            style={{ height: "50px", width: "50px" }}
            src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/close-icon-right.svg`}
            alt="right"
          />
        </NavButton>
      </div>
    </div>
  )
}

const OrbitManager = ({ configUrl }) => {
  let { loading, config, error } = useConfig(configUrl)

  if (config) {
    return <Orbits segments={config} />
  }

  if (error) {
    return <div>Missing Configuration: {configUrl}</div>
  }

  if (loading) {
    return <div>loading...</div>
  }
}

export default OrbitManager
